module.exports = __webpack_public_path__ + "static/media/sort-size-down.57c90111.svg";